if (!customElements.get('product-options')) {
  class ProductOptionPicker extends HTMLElement {
    constructor() {
      super();

      this.section = this.closest('.main-product');
      this.productOptions = this.querySelectorAll('ul');
      this.productOptionsList = this.querySelectorAll('li');
      this.productDropdowns = this.querySelectorAll('.product-option-picker__dropdown');

      this.sectionId = this.section.dataset.sectionId;
      this.productUrl = this.dataset.productUrl;

      // Toggle Option dropdown
      for (let dropdown of this.productDropdowns) {
        dropdown.addEventListener('click', (event) => {
          this.dropdown(dropdown, event);
        });

        document.addEventListener('click', (event) => {
          if (event.target !== dropdown && !dropdown.contains(event.target)) {
            this.closeDropdown(dropdown);
          }
        });
      }

      document.body.addEventListener('click', (event) => {
        var option = event.target.closest('.product-option-picker__list-item');
        if (option && !option.classList.contains('disabled') && !option.classList.contains('chosen')) {
          this.onClick(option);
        }
      });

      for (let productOption of this.productOptionsList) {
        productOption.addEventListener('focus', () => {
          productOption.addEventListener('keyup', (event) => {
            if (event.key === 'Enter') {
              productOption.click();
            }
          });
        });
      }
    }

    onClick(option) {
  // Mark selected option
  this.selectionPicker(option);

  // Get selected option values
  const selectedOptions = [];
  this.querySelectorAll('ul').forEach(ul => {
    const chosen = ul.querySelector('li.chosen');
if (chosen) {
  selectedOptions.push(chosen.dataset.optionValue);
}
  });

  // Get variants JSON
  const variantsData = JSON.parse(
    document.querySelector('[data-product-variants]').textContent
  );

  // Find matching variant
  const matchedVariant = variantsData.find(variant =>
    variant.options.every((opt, index) => opt === selectedOptions[index])
  );

  if (!matchedVariant) return;
  updatePriceFromVariant(matchedVariant);

  // Update variant ID in form
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) variantInput.value = matchedVariant.id;

  // 🔥 TRIGGER SHOPIFY VARIANT CHANGE EVENT
  variantInput.value = matchedVariant.id;

// 🔥 Trigger theme listeners
variantInput.dispatchEvent(new Event('input', { bubbles: true }));
variantInput.dispatchEvent(new Event('change', { bubbles: true }));

// 🔥 Trigger Shopify/app listeners
document.dispatchEvent(new CustomEvent('variant:change', {
  detail: { variant: matchedVariant }
}));

  // Update URL (safe with currency apps)
  const url = new URL(window.location.href);
  url.searchParams.set('variant', matchedVariant.id);
  history.replaceState({}, '', url);
}


    selectionPicker(option) {
      var currentDropdown = option.parentElement;
      var items = currentDropdown.querySelectorAll('li');

      items.forEach(item => item.classList.remove('chosen'));
      option.classList.add('chosen');
    }

    dropdown(dropdown) {
      dropdown.classList.contains('active')
        ? this.closeDropdown(dropdown)
        : this.openDropdown(dropdown);
    }

    openDropdown(dropdown) {
      dropdown.classList.add('active');
    }

    closeDropdown(dropdown) {
      dropdown.classList.remove('active');
    }
  }

  customElements.define('product-options', ProductOptionPicker);
}

/* =========================================================
   VARIANT + CURRENCY FIX (CRITICAL PART)
========================================================= */

// Load variant JSON
window.productVariants = window.productVariants || JSON.parse(
  document.querySelector('[data-product-variants]').textContent
);

// Proper Shopify variant update
function forceVariantPriceUpdate(section) {
  const variantInput = section.querySelector('input[name="id"]');
  if (!variantInput) return;

  const variantId = Number(variantInput.value);
  const variant = window.productVariants.find(v => v.id === variantId);
  if (!variant) return;

  document.dispatchEvent(new CustomEvent('variant:change', {
    detail: {
      variant: variant
    }
  }));
}

// Currency switch support
document.addEventListener('currency:changed', function () {
  document.querySelectorAll('.main-product').forEach(section => {
    forceVariantPriceUpdate(section);
  });
});


function updatePriceFromVariant(variant) {
  const priceWrappers = document.querySelectorAll(
    '.price, .product-price, [data-price]'
  );

  priceWrappers.forEach(wrapper => {
    const moneyFormat = window.Shopify?.money_format || '{{amount}}';
    const formattedPrice = Shopify.formatMoney(variant.price, moneyFormat);

    wrapper.innerHTML = formattedPrice;
  });
}
